import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import { getCollectionDetails } from './collectionDetailsApi'

const collectionAdapter = createEntityAdapter()

export const collectionDetailsSelector = collectionAdapter.getSelectors(
    state => state.collectionStudies
)

export const getDetails = createAsyncThunk('collection/details', async (arg, thunkAPI) => {
    try {
        const response = await getCollectionDetails(arg)
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

const initialState = {
    ...collectionAdapter.getInitialState(),
    loading: false,
    error: false,
}

const collectionDetailsSlice = createSlice({
    name: 'collectionStudies',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getDetails.pending, state => {
            state.loading = true
            state.error = false
        })
        builder.addCase(getDetails.fulfilled, (state, { payload }) => {
            collectionAdapter.upsertMany(state, payload.data.series)
            state.loading = false
        })
        builder.addCase(getDetails.rejected, state => {
            state.loading = false
            state.error = false
        })
    },
})

export default collectionDetailsSlice.reducer
